import { render, staticRenderFns } from "./MoleculeContentEditorBlockIframeVideo.vue?vue&type=template&id=4f8201fc&"
import script from "./MoleculeContentEditorBlockIframeVideo.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorBlockIframeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports